<template>
    <div class="contentHome">
        <div class="centerPage">
            <el-breadcrumb separator-class="el-icon-arrow-right" class="breadCrumb">
                <el-breadcrumb-item  :to="{path:'/consultation'}">
                    专家会议
<!--                    <a href="/consultation" class="aHref">专家会诊</a>-->
                </el-breadcrumb-item>
                <el-breadcrumb-item :to="{path:'/consultationDetail?id='+id}">
                    会议详情
<!--                    <a :href="'/consultationDetail?id='+id" class="aHref">会诊详情</a>-->
                </el-breadcrumb-item>
                <el-breadcrumb-item>我要报名</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="signUp flex">
                <div class="img" :style="'backgroundImage: url('+details.thumbnailPath+')'"></div>
                <div class="rightC">
                    <h3 class="overflow">{{details.title}}</h3>
                    <p>{{details.subTitle}}</p>
                    <span class="num">已报名<span>{{details.registerCount}}</span>人</span>
                </div>
            </div>
            <el-form ref="form" :model="signUpForm" id="signUpForm"
                     class="signUpForm" label-width="100px" label-suffix="：">
                <p class="title">提交报名信息</p>
                <div class="info">
                    <div class="common">
                        <el-form-item label="真实姓名">
                            <el-input v-model="signUpForm.name" placeholder="请输入姓名"></el-input>
                        </el-form-item>
                        <el-form-item label="所在城市">
                            <el-input v-model="signUpForm.abodeCity" placeholder="请输入所在城市"></el-input>
                        </el-form-item>
                        <el-form-item label="手机号码">
                            <el-input type="tel" v-model="signUpForm.mobile" placeholder="请输入手机号码"></el-input>
                        </el-form-item>
                    </div>
                    <div class="common">
                        <el-form-item label="年龄">
                            <el-input v-model="signUpForm.age" placeholder="请输入年龄"></el-input>
                        </el-form-item>
                        <el-form-item label="职业">
                            <el-input v-model="signUpForm.occupation" placeholder="请输入职业"></el-input>
                        </el-form-item>
                        <el-form-item label="邮箱账号">
                            <el-input type="tel" v-model="signUpForm.email" placeholder="请输入邮箱"></el-input>
                        </el-form-item>
                    </div>
                    <div class="common">
                        <el-form-item label="性别" class="sex">
                            <el-radio-group v-model="signUpForm.gender">
                                <el-radio label="1">男</el-radio>
                                <el-radio label="0">女</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </div>
                </div>
                <el-button @click="onSubmit">提交</el-button>
            </el-form>
        </div>
        <el-dialog
                :show-close="false"
                class="tips paySuccess"
                top="0"
                :visible.sync="dialogVisible"
                :close-on-click-modal = "false"
                :close-on-press-escape = "false"
                width="30%">
            <img src="../../assets/img/success.png" alt="" width="140">
            <p>提交成功！请准时参加会诊</p>
            <div class="sub">
                <el-button @click="success">我知道了</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import base from '@/api/common';
    import {Message,Loading} from 'element-ui';
    export default {
        name: "signUp",
        data() {
            return {
                id: this.$route.query.id,
                details:{},
                signUpForm: {
                    meetId: this.$route.query.id,
                    name: '',
                    abodeCity: '',
                    mobile: '',
                    age: '',
                    occupation: '',
                    email: '',
                    gender: '1'
                },
                dialogVisible: false,
            }
        },
        mounted() {
            // 报名信息
            this.$ajax.get(base.api.expert.consultation.base_info.replace("{id}",this.id)).then((res)=>{
                if(res.data.status === 'success'){
                    this.details = res.data.data;
                }
            });
        },
        methods: {
            onSubmit() {
                let load = Loading.service({target:"#signUpForm"});
                this.$ajax.post(base.api.expert.join.replace("{type}",1),this.signUpForm).then((res)=>{
                    load.close();
                    if(res.data.status === 'success'){
                        //
                        this.dialogVisible = true;
                    }else{
                        Message.error(res.data.message);
                    }
                });
            },
            success(){
                this.dialogVisible = false;
                this.$router.push({name: 'consultation'});
            }
        }
    }
</script>

<style scoped lang="scss">
    @import '../../assets/css/medication.scss';
</style>